(() => {
  const POS_KEY = 'dhc_signup_scroll_y';
  const PATH_KEY = 'dhc_signup_scroll_path';

  const isSignupForm = (form) =>
    form && form.matches('.dhc-v905-news__form, .dhc-email-popup__form, .dhc-news-form');

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!isSignupForm(form)) return;
    try {
      sessionStorage.setItem(POS_KEY, String(window.scrollY || 0));
      sessionStorage.setItem(PATH_KEY, window.location.pathname + window.location.search);
    } catch (_) {}
  }, true);

  const clearSignupHash = () => {
    const hash = (window.location.hash || '').toLowerCase();
    if (hash === '#contact_form' || hash.indexOf('#customer') === 0) {
      try {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } catch (_) {}
      return true;
    }
    return false;
  };

  const restore = () => {
    let saved = null;
    let savedPath = null;
    try {
      saved = sessionStorage.getItem(POS_KEY);
      savedPath = sessionStorage.getItem(PATH_KEY);
    } catch (_) {}

    const hadSignupHash = clearSignupHash();
    const currentPath = window.location.pathname + window.location.search;

    if (saved !== null && (!savedPath || savedPath === currentPath || hadSignupHash)) {
      const y = Math.max(0, Number(saved) || 0);
      const oldBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      requestAnimationFrame(() => window.scrollTo(0, y));
      setTimeout(() => {
        window.scrollTo(0, y);
        document.documentElement.style.scrollBehavior = oldBehavior;
      }, 80);
      try {
        sessionStorage.removeItem(POS_KEY);
        sessionStorage.removeItem(PATH_KEY);
      } catch (_) {}
    } else if (hadSignupHash) {
      window.scrollTo(0, 0);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore, {once:true});
  } else {
    restore();
  }
})();